import { createContext, useContext } from "react";

export const AccountCtx = createContext({ unread: 0, refreshUnread: () => {} });
export const useAccount = () => useContext(AccountCtx);
